<template>
  <div class="relative">
    <div class="line">
      <div class="line__fill"
           :style="{width:`${daysPassed}%`}"></div>
    </div>
    <div class="line__dates" v-show="showDays">
      <div class="item" v-show="currentMonthDay > 2">01</div>
      <div class="item current-item"
           :class="`status--${color}`"
           :style="{left:`${daysPassed}%`}">
        {{ currentMonthDay }}
      </div>
      <div class="item ml-auto" v-show="currentMonthDay < lastMonthDay - 1">{{ lastMonthDay }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyBudgetsPreviewDays",
  props: {
    daysPassed: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true,
      validator: (val) => ['redBlinking', 'red', 'orange', 'yellow', 'lightGreen', 'green'].includes(val)
    },
    showDays: {
      type: Boolean,
      default:true
    }
  },
  computed: {
    currentMonthDay() {
      return this.$moment().format('DD')
    },
    lastMonthDay() {
      return this.$moment().endOf('month').format('DD')
    }
  }
}
</script>

<style lang="scss">
.line {
  @apply border border-border rounded p-0-5 bg-block;
  &__fill {
    @apply h-2 rounded bg-budget-days-gradient;
  }

  &__dates {
    @apply flex justify-between pt-6 text-text-ternary;

    .item {
      @apply relative;
      &:before {
        @apply absolute bg-text-ternary left-0 right-0 mx-auto transform -translate-y-full;
        content: '';
        top: -2px;
        width: .1rem;
        height: .4rem;
      }
    }

    .current-item {
      @apply absolute transform -translate-x-1/2;
      &:before {
        height: .9rem;
      }

      &.status--redBlinking {
        animation: blinkRedOutline 2s infinite;
        @apply text-red;
        &:before {
          @apply bg-red;
        }
      }

      &.status--red {
        @apply text-red;
        &:before {
          @apply bg-red;
        }
      }

      &.status--orange {
        color: #FF7A00;

        &:before {
          background: #FF7A00;
        }
      }

      &.status--yellow {
        @apply text-yellow;
        &:before {
          @apply bg-yellow;
        }
      }

      &.status--lightGreen {
        @apply text-green-hover;
        &:before {
          @apply bg-green-hover;
        }
      }

      &.status--green {
        @apply text-green;
        &:before {
          @apply bg-green;

        }
      }
    }
  }
}

@keyframes blinkRedOutline {
  0%, 100% {
    text-shadow: 0px 2px 8px rgba(224, 64, 103, 0.6);
  }
  50% {
    text-shadow: 0px 4px 12px rgba(255, 40, 93, 0.9);
  }
}
</style>